import React, { useState } from "react";
import { Toggle, Modal } from "carbon-components-react";

import APIClient from "@eave/borrower/web_modules/APIClient";
import { LoanApplicationRate } from "@eave/shared/types/api";
import { rateIsLocked } from "@eave/shared/utils/rates";
const borrowerRateLockStyles = require("./styles.module.scss");

interface Props {
  activeRate: LoanApplicationRate;
  loanApplicationId: number;
  reloadLoanApp: Function;
}

function expireRate(rateId: number) {
  return APIClient.post(`/uw/loan_application_rates/${rateId}/expire`, {});
}

const UnlockBorrowerRate: React.FC<Props> = ({
  activeRate,
  loanApplicationId,
  reloadLoanApp,
}: Props) => {
  const [openModal, setOpenModal] = useState(false);

  const reset = () => {
    setOpenModal(false);
  };

  const showModal = () => {
    if (rateIsLocked(activeRate)) {
      setOpenModal(true);
    }
  };

  const expireActiveRate = () => {
    expireRate(activeRate.id)
      .catch(err => {
        alert(
          `there was an error expiring the rate, please contact engineering or reload the page and try again`,
        );
        throw new Error(`there was an error expiring the rateId: ${activeRate.id}. Error: ${err}`);
      })
      .finally(() => {
        setOpenModal(false);
        reloadLoanApp(loanApplicationId);
      });
  };

  return (
    <>
      <Modal
        open={openModal}
        modalHeading="Confirm Unlock Rate"
        primaryButtonText="Unlock Rate"
        secondaryButtonText="Cancel"
        onBlur={reset}
        onRequestClose={reset}
        onRequestSubmit={expireActiveRate}
        danger
      >
        Unlocking the rate will remove any price exceptions and bring the borrower to current rates.
        Are you sure you would like to unlock?
      </Modal>
      <Toggle
        id="ToggleRateUnlock"
        toggled={rateIsLocked(activeRate)}
        labelA="Not Selected"
        labelB="Locked"
        className={borrowerRateLockStyles.toggle}
        onToggle={showModal}
        disabled={!rateIsLocked(activeRate)}
      />
    </>
  );
};

export default UnlockBorrowerRate;
